import global from "global";

const prefersReducedAnimation = () =>
  global.matchMedia("(prefers-reduced-motion: reduce)").matches;

export default prefersReducedAnimation;
